<script setup>
import { ref, onMounted, getCurrentInstance, inject, computed } from "vue";
import { useRouter, RouterLink } from "vue-router";
import adminCorporationService from "../../services/corporation/adminCorporationService";
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import _ from "lodash";
import moment from "moment";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";
import { useAlertStore } from "../../../../stores/alertStore";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
import adminCorpInfoService from "@/pages/admin/services/corporation/adminCorpInfoService";
const {$alert, $confirm} = useAlertStore();
const router = useRouter();

const loadingStore = usePageLoadingStore();
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo, $toast, $number, $yyyymmddHHmmss, $bizNum } = getCurrentInstance().appContext.config.globalProperties;


onMounted(() => {
    retrieveList();
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchPageSizeRef = ref(null);
const searchOpen = ref(true);

const industryGbOptions = ref(globals.$industryGb || []);
const corpGbOptions = ref(globals.$corpGb || []);
const corpPublicYnOptions = ref(globals.$corpPublicYn || []);

const industryGbListRef = ref(null);
const corpGbListRef = ref(null);
const corpPublicYnListRef = ref(null);
const workAreaCorpRef = ref(null);
const searchTypeRef = ref(null)
const searchDurationGbRef = ref(null)
const searchOrderByRef = ref(null);  // 정렬
const datepickerTermsRef = ref(null);

const onSelectedCorpArea1Option = (option) => {
  _searchInput.value.workArea1 = option === '시/도 선택' ? '' : option;
};

const onSelectedCorpArea2Option = (option) => {
 _searchInput.value.workArea2 = option === '시/구/군 선택' ? '' : option;
};

const list = ref([]);


// 검색 조건
const getInitialSearchInput = () => ({
    searchType: 'corpName', // corpName 기업명, bizNum 사업자등록번호
    searchInput: '',
    searchDurationGb: 'C', // C 최초 등록일 L 최근 수정일
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    orderProperty: '',
    orderDirection: '',
    searchIndustryGbs: industryGbOptions.value.map(item => item.value),
    searchCorpGbs: corpGbOptions.value.map(item => item.value),
    searchCorpPublicYn: corpPublicYnOptions.value.map(item => item.value),
    searchBizType: '',
    workArea1: '',
    workArea2: '',
});

const _searchInput = ref(getInitialSearchInput());

const searchTypeGroup = ref([
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"사업자등록번호", value: "bizNum", placeholder: "사업자등록번호를 입력해주세요." },
]);

const searchInputPlaceholder = computed(()=>{
    const option = _.find(searchTypeGroup.value, { value: _searchInput.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchDurationGbGroup = ref([
    { label:"최초 등록일", value: "C" },
    { label:"최근 수정일", value: "L" },
])

const searchDurationTypeGroup = ref([
    { label:"모든 기간", value: "all" },
    { label:"기간 검색", value: "term" },
])

// 검색조건 - 정렬
const orderByGroup = [
    { label: '정렬', value: ''},
    { label: '기업명 오름차순', value: 'corpName ASC'},
    { label: '기업명 내림차순', value: 'corpName DESC'},
    { label: '최근 수정일 빠른순', value: 'modifyDate ASC'},
    { label: '최근 수정일 느린순', value: 'modifyDate DESC'},
    { label: '최초 등록일 빠른순', value: 'createDate ASC'},
    { label: '최초 등록일 느린순', value: 'createDate DESC'},
    { label: '재직자 가입 수 많은순', value: 'userCnt DESC'},
    { label: '재직자 가입 수 작은순', value: 'userCnt ASC'},
]

const pageSizeGroup = ref([
    { label: "10개씩 보기", value: "10" },
    { label: "30개씩 보기", value: "30" },
    { label: "50개씩 보기", value: "50" },
    { label: "100개씩 보기", value: "100" }
]);

const retrieveList = async () => {
    let paramObj = {
        searchType: _searchInput.value.searchType,
        searchInput: _searchInput.value.searchInput,
        searchDurationGb: _searchInput.value.searchDurationGb,
        startYmd: _searchInput.value.searchDurationType === 'all' ? "" : _searchInput.value.startYmd,
        endYmd: _searchInput.value.searchDurationType === 'all' ? "" : _searchInput.value.endYmd,
        pageNumber: currentPage.value,
        size: pageSize.value,
        orderProperty: _searchInput.value.orderProperty,
        orderDirection: _searchInput.value.orderDirection,
        searchIndustryGbs: _searchInput?.value.searchIndustryGbs?.join(',') || "",
        searchCorpGbs: _searchInput?.value.searchCorpGbs?.join(',') || "",
        searchCorpPublicYn: _searchInput?.value.searchCorpPublicYn?.join(',') || "",
        searchBizType: _searchInput?.value.searchBizType || "",
        searchResidences: `${_searchInput?.value.workArea1 || ''}${_searchInput?.value.workArea1 ? ' ' : ''}${_searchInput?.value.workArea2 || ''}`,
    };

    loadingStore.loading = true;
    adminCorporationService.retrieveAllCorporationListPaging(paramObj)
        .then( (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements
                list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            } else {

            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

const downloadCorporationList = () => {
    $toast('', `다운로드 데이터 생성을 시작합니다.`);
    loadingStore.loading = true;

    let paramObj = {
      searchType: _searchInput.value.searchType,
      searchInput: _searchInput.value.searchInput,
      searchDurationGb: _searchInput.value.searchDurationGb,
      startYmd: _searchInput.value.searchDurationType === 'all' ? "" : _searchInput.value.startYmd,
      endYmd: _searchInput.value.searchDurationType === 'all' ? "" : _searchInput.value.endYmd,
      pageNumber: currentPage.value,
      size: pageSize.value,
      orderProperty: _searchInput.value.orderProperty,
      orderDirection: _searchInput.value.orderDirection,
      searchIndustryGbs: _searchInput?.value.searchIndustryGbs?.join(',') || "",
      searchCorpGbs: _searchInput?.value.searchCorpGbs?.join(',') || "",
      searchCorpPublicYn: _searchInput?.value.searchCorpPublicYn?.join(',') || "",
      searchBizType: _searchInput?.value.searchBizType || "",
      searchResidences: `${_searchInput?.value.workArea1 || ''}${_searchInput?.value.workArea1 ? ' ' : ''}${_searchInput?.value.workArea2 || ''}`,
    };

    adminCorporationService.retrieveAllCorporationListExcel(paramObj)
        .then( (res) => {
            loadingStore.loading = false;
            try {
                const href = URL.createObjectURL(res.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${moment().format("YYYYMMDD")}_기업리스트.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            } catch(e) {
                console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
            }
        }).catch( (err) =>  {
            loadingStore.loading = false;
            let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
            // Blob 응답 처리
            err.response.data.text()  // Blob을 텍스트로 변환
                .then(text => {
                    try {
                        // 텍스트를 JSON으로 파싱
                        const responseData = JSON.parse(text);
                        // 메시지 추출
                        if (responseData?.result?.message) {
                            errorMessage = responseData.result.message;
                        }
                    } catch (parseError) {
                        console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
                    }
                    // Toast에 에러 메시지 표시
                    $toast('error', errorMessage);
                });
        });
}

const clearSearchInput = () => {
    Object.assign(_searchInput.value, getInitialSearchInput());

    searchTypeRef.value.initSelectedOption(_searchInput.value.searchType);
    searchDurationGbRef.value.initSelectedOption(_searchInput.value.searchDurationGb);

    if (datepickerTermsRef.value && typeof datepickerTermsRef.value.initDates === 'function') {
        datepickerTermsRef.value.initDates();
    }
    if (industryGbListRef.value && industryGbListRef.value.initOptions) {
      industryGbListRef.value.initOptions();
    }
    if (corpGbListRef.value && corpGbListRef.value.initOptions) {
      corpGbListRef.value.initOptions();
    }
    if (corpPublicYnListRef.value && corpPublicYnListRef.value.initOptions) {
      corpPublicYnListRef.value.initOptions();
    }
    if (workAreaCorpRef.value && workAreaCorpRef.value.initSelectedOption) {
      workAreaCorpRef.value.initSelectedOption('시/도 선택', '시/구/군 선택');
    }
};

const onSelectSearchTypeGroup = (option) => {
    _searchInput.value.searchType = option.value;
}

const onSelectSearchDurationGbGroup = (option) => {
    _searchInput.value.searchDurationGb = option.value;
}

const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
};

const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
};

const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
};

// 정렬 셀렉트 박스 선택
const onSelectOrderBy = (option) => {
    loadingStore.loading = true;
    const [orderProperty, orderDirection] = option.value.split(" ");
    currentPage.value = 1;
    _searchInput.value.orderProperty = orderProperty;
    _searchInput.value.orderDirection = orderDirection;
    retrieveList();
}

// 기업홍보관 공개 여부
const onClickChangeCorpInfoOpenYn = async (corpId, corpInfoOpenYn) => {
  let ok;

  // corpInfoOpenYn Y인지 아닌지 check
  // if ( corpInfoOpenYn === 'Y') { // 공개
  //   ok = await $confirm(["해당 기업을 기업홍보관에 공개 하시겠습니까?"], "확인");
  // } else { // 비공개
  //   ok = await $confirm(["해당 기업을 기업홍보관에 비공개 하시겠습니까?"], "확인");
  // }

  let paramObj = {
    corpId: corpId,
    corpInfoOpenYn: corpInfoOpenYn,
  }
  adminCorpInfoService.updateStatusCorpInfoOpenYn(paramObj)
      .then( async (res) => {
        if (res.data.code.toLowerCase() === 'success') {
          //let result = res.data.result;
          //console.log(result);
          if(corpInfoOpenYn === 'Y') {
            $alert(["선택한 기업의 기업정보가", "기업홍보관에 공개 처리되었습니다."]);
          } else if(corpInfoOpenYn === 'N') {
            $alert(["선택한 기업의 기업정보가", "기업홍보관에 비공개 처리되었습니다."]);
          }
          loadingStore.loading = false;
          retrieveList();
        }
      }).catch((error) => {
    loadingStore.loading = false;
  });
}

// 엑셀 다운로드
const onClickExcelDownload = async () => {
    if(totalCount.value > 0) {
        const ok = await $confirm(["기업목록을 내 PC로 다운로드할까요?"], "다운로드");
        if(ok){
            downloadCorporationList();
        }
    } else {
        $alert("다운로드 받을 '기업목록'이 존재하지 않습니다.");
        return false;
    }
}
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>기업 목록</h3>
        </div>
        <!-- s: 검색 -->
        <div class="filter-wrap" :class="{'open': searchOpen}">
            <p @click="searchOpen = !searchOpen">검색</p>
            <div class="filter">
                <dl>
                    <dt>
                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectSearchTypeGroup"/>
                    </dt>
                    <dd>
                        <KSAInput class="text-box" v-model="_searchInput.searchInput" :placeholder="searchInputPlaceholder" />
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <KSASelect ref="searchDurationGbRef" :options="searchDurationGbGroup" class="select" @selectOption="onSelectSearchDurationGbGroup"/>
                    </dt>
                    <dd class="text-box">
                        <div class="grid">
                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="_searchInput.searchDurationType" :value="group.value" />
                            </template>
                            <div style="display: inline-block;" v-show="_searchInput.searchDurationType !== 'all'">
                                <KSADatepickerTerms
                                    ref="datepickerTermsRef"
                                    :startDate="_searchInput.startYmd"
                                    :endDate="_searchInput.endYmd"
                                    @update:startDate="(value)=> _searchInput.startYmd = value"
                                    @update:endDate="(value)=> _searchInput.endYmd = value"
                                />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                  <dt>산업군</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="industryGbListRef"
                        className="mr-md"
                        name="industryGbs"
                        v-model="_searchInput.searchIndustryGbs"
                        :options="industryGbOptions" />
                  </dd>
                </dl>
                <dl>
                  <dt>기업형태</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="corpGbListRef"
                        className="mr-md"
                        name="corpGbs"
                        v-model="_searchInput.searchCorpGbs"
                        :options="corpGbOptions" />
                  </dd>
                </dl>
                <dl>
                  <dt>상장여부</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="corpPublicYnListRef"
                        className="mr-md"
                        name="corpPublicYns"
                        v-model="_searchInput.searchCorpPublicYn"
                        :options="corpPublicYnOptions" />
                  </dd>
                </dl>
                <dl>
                  <dt>업종</dt>
                  <dd>
                    <KSAInput class="text-box" v-model="_searchInput.searchBizType" placeholder="업종을 입력해주세요." />
                  </dd>
                </dl>
                <dl>
                  <dt>사업장소재지</dt>
                  <dd>
                    <KSASelectResidenceArea
                        class="select"
                        ref="workAreaCorpRef"
                        @selectOption1="onSelectedCorpArea1Option"
                        @selectOption2="onSelectedCorpArea2Option"
                    />
                  </dd>
                </dl>
                <div class="btn-wrap">
                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
            </div>
        </div>
        <!-- e: 검색 -->
        <!-- s: 버튼영역 -->
        <div class="list-top">
            <KSASecondaryButton class="gray_button" text="엑셀 다운로드" @click="onClickExcelDownload" />
        </div>
        <div class="list-top">
            <p>전체 <span>{{ $number(totalCount) }}</span>건</p>
            <div class="grid">
                <KSASelect ref="searchOrderByRef" :options="orderByGroup" class="select" @selectOption="onSelectOrderBy"/>
                <KSASelect ref="searchPageSizeRef" :options="pageSizeGroup" class="select ml-xs" @selectOption="onSelectPageSize" />
            </div>
        </div>
        <!-- e: 버튼영역 -->
        <!-- s: 기업 리스트 -->
        <div class="table-form">
            <table class="horizontal" v-if="list !== null">
                <tr>
                    <th>NO</th>
                    <th>기업명</th>
                    <th>사업자등록번호</th>
                    <th>최근 수정일</th>
                    <th>최초 등록일</th>
                    <th>재직자 가입 수</th>
                    <th>마스터</th>
                    <th>기업정보 등록 여부</th>
                    <th>기업홍보관 공개</th>
                </tr>
                <tr v-for="corporation in list">
                    <td>{{ corporation.boardNo }}</td>
                    <td class="clickable blue text-overflow long-overflow">
                        <RouterLink :to="{name:'CorporationDetail', params:{id: corporation.corpId}}">{{corporation.corpName}}</RouterLink>
                    </td>
                    <td>{{ $bizNum(corporation.bizNum) }}</td>
                    <td>{{ $yyyymmddHHmmss(corporation.modifyDate) }}</td>
                    <td>{{ $yyyymmddHHmmss(corporation.createDate) }}</td>
                    <td>{{ corporation.userCnt }}</td>
                    <td v-if="corporation.userName === ''">-</td>
                    <td v-else class="clickable blue">
                        <p @click="router.push({name:'MemberDetail', params:{id:corporation.userId}})">{{corporation.userName}}</p>
                    </td>
                    <td>
                      <span v-if="corporation.corpInfoYn === 'Y'">등록 완료</span>
                      <span v-else>미등록</span>
                    </td>
                    <td>
                        <div v-if="corporation.corpInfoYn === 'Y' && corporation.userName">
                          <span v-if="corporation.corpInfoOpenYn === 'Y'">
                            <img src="../../../../assets/images/toggle_on.png" @click="onClickChangeCorpInfoOpenYn(corporation.corpId, 'N')" style="cursor:pointer;" />
                          </span>
                            <span v-else>
                            <img src="../../../../assets/images/toggle_off.png" @click="onClickChangeCorpInfoOpenYn(corporation.corpId, 'Y')" style="cursor:pointer;" />
                          </span>
                        </div>
                        <div v-else>-</div>
                    </td>
                </tr>
            </table>
            <div class="result-none" v-if="list.length === 0">
                등록된 기업이 없습니다.
            </div>
        </div>
        <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
        <!-- e: 기업 리스트 -->
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
.blue {
  color: $blue_color;
}
.list-top .custom-select {
  width: 210px !important;
}
.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
